import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { getFieldsForCreateRequest } from 'components/form-multi/utils';

import { toggleSpinner } from 'actions/appAction';
import { initCalculator } from 'actions/calculatorAction';
import { updateFields } from 'actions/formAction';
import { updatePageMessages } from 'actions/messageAction';

import { REQ_ERROR, VALID_ERROR } from 'constants/Constants';

import { apiFetchData, changeBrowserUrlWithOutReload } from 'helpers/api';
import { countryPropType } from 'helpers/customPropTypes';
import { getLangCountryPrefix, resolveArguments } from 'helpers/utils';

import { useHandleCloseDropdownMenu } from 'hooks/useHandleCloseDropdownMenu';

import AmountCurrency from './AmountCurrency';
import { AmountRow } from './styles';
import { PromoHintContainer } from '../../form-multi/styles';
import { PromoDangerouslyHtml } from '../../no-auth/common/PromoDangerouslyHtml/PromoDangerouslyHtml';
import PromoInputAmount from '../../no-auth/form/PromoInputAmount';
import PromoCountryList from '../CalculatorDropdown/PromoCountryList';

const RequestAmountTo = (props) => {
    const [showCountryList, setShowCountryList] = useState(true);
    const [selectedCountry, setSelectedCountry] = useState({});

    const wrapperRef = useRef(null);
    const [isOpenDropdownMenu, setOpenDropdownMenu] = useHandleCloseDropdownMenu(wrapperRef);

    const getUrl = (country, currency) => {
        const fromCountryName = props.countryFrom.seoNameFrom;
        const toCountryName = country.seoNameTo;
        const toCountryCode = currency.id;
        const dependedURI = resolveArguments(props.localeDependentURI, [fromCountryName, toCountryName]);
        return `${getLangCountryPrefix(props.lang, props.country)}${dependedURI}?toCurrId=${toCountryCode}`;
    };

    useEffect(() => {
        setShowCountryList(true);
    }, [isOpenDropdownMenu]);

    const selectCountry = (e, country, currency, isSelect) => {
        e.preventDefault();
        if (country.currencies.length > 1) {
            if (isSelect) {
                initSelectedCountry(e, country, currency);
            } else {
                setShowCountryList(false);
                setSelectedCountry(country);
            }
        } else {
            initSelectedCountry(e, country, currency);
        }
    };

    const initSelectedCountry = (e, country, currency) => {
        props.toggleSpinner(true);
        setShowCountryList(true);

        setOpenDropdownMenu(false);

        const url = getUrl(country, currency);
        if (!props.isLanding && props.submitRef && props.submitRef.current) {
            props.updateFormProperties(props.formName, url, false).then(() => props.submitRef.current.click());
            changeBrowserUrlWithOutReload(url);
        } else {
            apiFetchData(url)
                .then((data) => {
                    props.updateFields(props.formName, getFieldsForCreateRequest(data));
                    props.updatePageMessages(data.messages);
                    props.initCalculator(data);
                    changeBrowserUrlWithOutReload(url, data);
                    props.toggleSpinner(false);
                })
                .catch(() => props.toggleSpinner(false));
        }
    };

    const getErrorText = (field) => {
        const errorMessageKey = field.value ? VALID_ERROR : REQ_ERROR;
        return field.errorMessage ? field.errorMessage : props.jsMessages[errorMessageKey];
    };

    const closeCurrencyButton = (e, country) => {
        e.preventDefault();
        setShowCountryList(true);
        setSelectedCountry(country);
    };

    const countryBean = props.countryBean;
    const amountFieldBean = props.amountFieldBean;
    const fields = props.forms[props.formName].fields;
    const amountField = fields[amountFieldBean.name];
    const isShowList = props.countryList && props.countryList.length > 1;

    return (
        <AmountRow isLock={props.isLock} ref={wrapperRef}>
            {isOpenDropdownMenu && isShowList ? (
                <PromoCountryList
                    showCountryList={showCountryList}
                    selectedCountry={selectedCountry}
                    countryList={props.countryList}
                    isFrom={props.isFrom}
                    handlerSelectCountry={selectCountry}
                    handlerCloseButtonCurrencyCountry={closeCurrencyButton}
                    showCurrencies
                />
            ) : (
                <PromoInputAmount
                    field={amountField}
                    formName={props.formName}
                    minAmount={amountFieldBean.minValidValue}
                    maxAmount={amountFieldBean.maxValidValue}
                    enabledValidateMinMaxAmount={props.enabledValidateMinMaxAmount}
                    onChangeHandler={props.onChangeHandler}
                    isLanding={props.isLanding}
                >
                    <AmountCurrency
                        isShowList={isShowList}
                        amountFieldBean={amountFieldBean}
                        countryBean={countryBean}
                        handlerToggleMenu={() => setOpenDropdownMenu(true)}
                    />
                </PromoInputAmount>
            )}
            {amountField.isError && (
                <PromoHintContainer>
                    <PromoDangerouslyHtml dangerouslyHtml={getErrorText(amountField)} tag="div" color="error" />
                </PromoHintContainer>
            )}
        </AmountRow>
    );
};

RequestAmountTo.propTypes = {
    isFrom: PropTypes.bool.isRequired,
    isSend: PropTypes.bool.isRequired,
    formName: PropTypes.string.isRequired,
    amountFieldBean: PropTypes.object.isRequired,
    countryBean: countryPropType,
    countryTo: countryPropType,
    countryFrom: countryPropType,
    countryList: PropTypes.arrayOf(countryPropType),
    isLock: PropTypes.bool,
};

RequestAmountTo.defaultProps = {
    isLock: false,
    amountFieldBean: {},
    isLanding: false,
    enabledValidateMinMaxAmount: true,
};
const mapStateToProps = (state) => {
    return {
        forms: state.form,
        lang: state.language.lang,
        country: state.app.country,
        messages: state.messages.pageMessages,
        jsMessages: state.messages.jsMessages,
    };
};
export default connect(mapStateToProps, { toggleSpinner, updateFields, initCalculator, updatePageMessages })(RequestAmountTo);
